import { settingsService } from '../../services/settings.service'

const state = {
  defaultInvoiceNotes: ""
}

const mutations = {
  setDefaultInvoiceNotes(state, notes) {
    state.defaultInvoiceNotes = notes
  }
}

const actions = {
  fetchDefaultInvoiceNotes({ commit }) {
    return settingsService.getSettingByKey('DEFAULT_INVOICE_NOTES').then(setting => {
      commit('setDefaultInvoiceNotes', setting.value || "")
    })
  },
  saveDefaultInvoiceNotes({ commit }, notes) {
    return settingsService.updateSetting('DEFAULT_INVOICE_NOTES', notes).then(() => {
      commit('setDefaultInvoiceNotes', notes)
    })
  }
}

export const settings = {
  namespaced: true,
  state,
  mutations,
  actions
}
